(function () {
  function init() {
    var options = document.querySelectorAll('.sd-option');
    if (!options.length) return;

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        // Aktiv-Status setzen
        options.forEach(function (o) { o.classList.remove('is-active'); });
        option.classList.add('is-active');

        var variantId = option.getAttribute('data-variant-id');
        var price = option.getAttribute('data-price');
        var comparePrice = option.getAttribute('data-compare-price');

        // 1. Nativen Varianten-Selektor triggern (alle möglichen Varianten)
        var triggered = false;

        // variant-selects (Dawn)
        var vs = document.querySelector('variant-selects');
        if (vs) {
          var optVal = option.getAttribute('data-option-value');
          var radio = vs.querySelector('input[type="radio"][value="' + optVal + '"]');
          if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', {bubbles:true})); triggered = true; }
          if (!triggered) {
            var sel = vs.querySelector('select');
            if (sel) { sel.value = optVal; sel.dispatchEvent(new Event('change', {bubbles:true})); triggered = true; }
          }
        }

        // variant-radios (Dawn alternative)
        if (!triggered) {
          var vr = document.querySelector('variant-radios');
          if (vr) {
            var optVal2 = option.getAttribute('data-option-value');
            var radio2 = vr.querySelector('input[type="radio"][value="' + optVal2 + '"]');
            if (radio2) { radio2.checked = true; radio2.dispatchEvent(new Event('change', {bubbles:true})); triggered = true; }
          }
        }

        // 2. Formular direkt aktualisieren (immer)
        document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function(i){ i.value = variantId; });

        // 3. Preis manuell aktualisieren (immer als Fallback)
        var priceFormatted = 'CHF ' + (parseInt(price) / 100).toFixed(2);
        var comparePriceFormatted = 'CHF ' + (parseInt(comparePrice) / 100).toFixed(2);

        document.querySelectorAll('.price__regular .price-item--regular, .price-item--regular, [data-product-price]').forEach(function(el){
          el.innerHTML = priceFormatted;
        });
        document.querySelectorAll('.price__sale .price-item--regular, .price-item--regular s, [data-compare-price]').forEach(function(el){
          el.innerHTML = comparePriceFormatted;
        });

        // 4. URL aktualisieren
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        } catch(e) {}
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
